export enum ProcedureSignatureType {
    Preparer = 1,
    Reviewer = 2,
    Approver = 3
}